<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div
            v-if="Object.keys(validation_errors).length !== 0"
            class="alert alert-danger alert-dismissible fade show"
            role="alert">
            <span v-for="(err, index) in validation_errors" :key="index">
              {{ err[0] }} <br />
            </span>
          </div>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6">
                <label for="batch_id" class="col-form-label col-form-label-sm">Select Batch <span style="color: red">*</span></label>
                <select
                  v-model="search_data.batch_id"
                  id="batch_id"
                  name="batch_id"
                  v-validate="'required'"
                  class="form-control form-control-sm"
                >
                  <option :value="''" selected>Select Batch</option>
                  <option
                    v-for="(batch, index) in t_batches"
                    :key="index"
                    :value="batch.id"
                  >
                    {{
                      batch.trade.desc + " | " + "Batch No: " + batch.batch_no
                    }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please Select Batch
                </div>
              </div>
              <div class="col-md-6 custom-search">
                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">Search</button>
              </div>
            </div>
          </form>
        </b-card>

        <b-card>
          <div v-if="batch_trainees.total > 0" class="row mb-2">
            <div class="col-sm-4">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ batch_trainees.total }}</span>
              <b-dropdown variant="default" style=" background-color: #d4d4d4; border-color: #8c8c8c;">
                <template v-slot:button-content>
                  <i class="fa fa-cog"></i>
                </template>
                <b-dropdown-form style="width: 207px !important; overflow-y: auto">
              <span v-for="(checkboxArray, index) in checkboxArrays" :key="index" class="ml-3">
                <input type="checkbox" v-model="selected" :value="checkboxArray" :id="checkboxArray">&nbsp;{{ checkboxArray }} <br>
              </span>
                </b-dropdown-form>
              </b-dropdown>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th v-if="isVisible('Form No.')">Form No.</th>
                <th v-if="isVisible('Household Number')">Household Number</th>
                <th v-if="isVisible('Name')">Name</th>
                <th v-if="isVisible('NID')">NID(ID Type)</th>
                <th v-if="isVisible('Mobile')">Mobile</th>
                <th v-if="isVisible('Gender')">Gender</th>
                <th v-if="isVisible('Father Name')">Father Name</th>
                <th v-if="isVisible('Mother Name')">Mother Name</th>
                <th v-if="isVisible('Village')">Village</th>
                <th v-if="isVisible('Mouza')">Mouza</th>
                <th v-if="isVisible('Rep Name')">Rep. Name</th>
                <th v-if="isVisible('Rep Father Name')">Rep. Father/Husband Name</th>
                <th v-if="isVisible('Rep Mother Name')">Rep Mother Name</th>
                <th v-if="isVisible('Rep Relation')">Rep Relation</th>
                <th v-if="isVisible('Rep DOB')">Rep DOB</th>
                <th v-if="isVisible('Rep Gender')">Rep Gender</th>
                <th v-if="isVisible('Rep NID')">Rep NID</th>
                <th v-if="isVisible('Rep Mobile')">Rep Mobile</th>
                <th v-if="isVisible('Field Book')">Field Book</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trainee, index) in batch_trainees.data" :key="index">
                <td>{{ index + 1 }}</td>
                <td v-if="isVisible('Form No.')">{{ trainee.form_no }}</td>
                <td v-if="isVisible('Household Number')">{{ trainee.household_number }}</td>
                <td v-if="isVisible('Name')">
                  <router-link :to="{
                            name: 'traineeView',
                            params: { trainee_id: trainee.id }}" tag="a" title="Trainee Details" target="_blank">

                              <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                  <span v-if="image.file_tag === '1'">
                                    <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                                  </span>
                              </span>
                    {{ trainee.name }}
                  </router-link>
                </td>
                <td v-if="isVisible('NID')">{{ trainee.nid }}({{ trainee.id_type }})</td>
                <td v-if="isVisible('Mobile')">{{ trainee.mobile }}</td>
                <td v-if="isVisible('Gender')">{{ trainee.gender.desc }}</td>
                <td v-if="isVisible('Father Name')">{{ trainee.father_husband_name }}</td>
                <td v-if="isVisible('Mother Name')">{{ trainee.mother_name }}</td>
                <td v-if="isVisible('Village')">{{ trainee.village.desc }}</td>
                <td v-if="isVisible('Mouza')">{{ trainee.mouza.desc }}</td>
                <td v-if="isVisible('Rep Name')">
                    <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                          <span v-if="image.file_tag === '2'">
                            <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                          </span>
                      </span>
                  {{ trainee.rep_name }}
                </td>
                <td v-if="isVisible('Rep Father Name')">{{ trainee.rep_father_husband_name }}</td>
                <td v-if="isVisible('Rep Mother Name')">{{ trainee.rep_mother_name }}</td>
                <td v-if="isVisible('Rep Relation')"><span v-if="trainee.family_relation !== null">{{ trainee.family_relation.desc }}</span></td>
                <td v-if="isVisible('Rep DOB')">{{ trainee.rep_dob }}</td>
                <td v-if="isVisible('Rep Gender')"><span v-if="trainee.rep_gender !== null">{{ trainee.rep_gender.desc }}</span></td>
                <td v-if="isVisible('Rep NID')"><span v-if="trainee.rep_nid !== null">{{ trainee.rep_nid }}({{ trainee.rep_id_type }})</span></td>
                <td v-if="isVisible('Rep Mobile')">{{ trainee.rep_mobile }}</td>
                <td v-if="isVisible('Field Book')">{{ trainee.field_book_sl }}</td>
                <td>
                  <span v-if="userPermission.includes('trainee-to-batch-update')" >
                    <a href="javascript:void(0);"
                       v-if="current_date < trainee.end_date" class="action-icon" title="Update"
                       @click.prevent="getBatchId(trainee.id,trainee.trainee_id,trainee.batch_id),getBatches(),$bvModal.show('add-trainee-modal')">
                    <i class="mdi mdi-square-edit-outline editButton"></i>
                  </a>
                  </span>
                  <span v-if="userPermission.includes('trainee-to-batch-delete')">
                    <a href="javascript:void(0);"
                       v-if="current_date < trainee.end_date" class="action-icon" title="Remove"
                       @click.prevent="onDelete(trainee.batch_id, trainee.trainee_id, index)">
                    <i class="mdi mdi-delete-variant deleteButton"></i>
                  </a>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <h5
            v-if="batch_trainees.length === 0"
            class="text-center text-secondary"
          >
            No Data Found
          </h5>
          <div class="float-right">
            <pagination :data="batch_trainees" :limit="2" @pagination-change-page="getResults"></pagination>
          </div>
        </b-card>
      </div>
    </div>
    <add-to-batch
      :batches="batches"
      :trainee_id="trainee_id"
      :batch_id="batch_id"
      :batch_trainee_id="batch_trainee_id"
      :btn_edit="btn_edit"
      @search="search"
      @getBatches="getBatches"
    ></add-to-batch>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";

import AddToBatch from "../../modals/AddToBatch";

export default {
  page: {
    title: "List Trainee",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, AddToBatch },
  data() {
    return {
      title: "Search Trainee",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Trainee",
          href: "/batch/trainee/list"
        },
        {
          text: "List",
          active: true
        }
      ],
      batch_trainees: {},
      search_data: {
        batch_id: '',
      },
      villages: [],
      batches: [],
      trainee_id: "",
      batch_id: "",
      btn_edit: false,
      current_date: "",
      batch_trainee_id: "",
      validation_errors: {},
      t_batches: [],
      checkboxArrays: ['Form No.', 'Household Number', 'Name', 'NID', 'Mobile', 'Gender', 'Father Name', 'Mother Name', 'Village', 'Mouza', 'Rep Name', 'Rep Father Name', 'Rep Mother Name', 'Rep Relation', 'Rep DOB', 'Rep Gender', 'Rep NID', 'Rep Mobile', 'Field Book'],
      selected: ['Form No.', 'Household Number', 'Name', 'Father Name', 'Village', 'Rep Name', 'Rep Father Name'],
    };
  },
  mounted() {
    this.getBatch();
    this.getBatches();
    this.checkCurrentDate();
  },
  methods: {
    search() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/batch/trainee/getTrainee", this.search_data)
            .then(response => {
              if (!response.error) {
                this.batch_trainees = response.data.batch_trainees;
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
            });
        }
      });
    },
    getBatch() {
      http.get("api/batch/trainee/getBatch").then(response => {
        if (!response.error) {
          this.t_batches = response.data.batches;
        }
      });
    },
    getBatches() {
      http.get("api/getBatches").then(response => {
        if (!response.error) {
          this.batches = response.data.batches;
        }
      });
    },
    getBatchId(id, trainee_id, batch_id) {
      this.btn_edit = true;
      this.batch_trainee_id = id;
      this.batch_id = batch_id;
      this.trainee_id = trainee_id;
    },
    onDelete(batch_id, trainee_id, index) {
      if (confirm("Do you really want to delete?")) {
        http
          .post("api/batch/trainee/delete", { batch_id, trainee_id })
          .then(response => {
            if (response.data.permissionError) {
              this.$bvToast.toast(response.data.permissionError, {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger"
              });
            }else{
              this.batch_trainees.data.splice(index, 1);
              this.$bvToast.toast(response.data.message, {
                title: "Success",
                autoHideDelay: 5000,
                variant: "success"
              });
            }
          });
      }
    },
    checkCurrentDate() {
      this.current_date = moment().format("YYYY-MM-DD");
    },
    getResults(page = 1) {
      http.post('api/batch/trainee/getTrainee?page=' + page, this.search_data)
              .then(response => {
                this.batch_trainees = response.data.batch_trainees;
              });
    },
    isVisible(row) {
      const matchedValue = this.checkboxArrays.find(
              v => row === v
      );

      if (!matchedValue) {
        return true;
      }
      return this.selected.includes(matchedValue);
    }
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    }
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
<style>
  @media only screen and (min-width: 768px)  {
    .custom-search{
      margin-top: 30px;
    }
  }

  @media only screen and (max-width: 768px)  {
    .custom-search-button{
      margin-top: 8px;
    }
  }

  @media only screen and (max-width: 414px)  {
    .custom-search-button{
      margin-top: 8px;
    }
  }
</style>